<template>
  <v-card flat>
    <v-card-title>
      Telemetry statistic
    </v-card-title>
    <v-card-text>
      <v-expansion-panels
        v-model="panel"
        accordion
      >
        <v-expansion-panel>
          <v-expansion-panel-header><b>Filters</b></v-expansion-panel-header>
          <v-expansion-panel-content>
            <presets-autocomplete
              @update="presetSelected"
            />
            <map-id-autocomplete
              v-model="map_id"
            />
            <session-filters
              ref="sessionFilters"
              :map-id="map_id"
              :use-narration-nodes="true"
              :use-session-min-time="true"
              :update-narration-nodes-list="['build_id', 'user_id', 'session_id']"
              @update="updateFilters"
              @remove-finish="removeFinish"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="primary"
      >
        <v-tab
          v-for="item in tabItems"
          :key="item.name"
          :to="{ path: `/telemetry/statistic/${item.path}`, query: $route.query }"
          :exact="true"
          link
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <router-view />
    </v-card-text>
  </v-card>
</template>

<script>
import PresetsAutocomplete from '../../components/filters/Telemetry/PresetsAutocomplete.vue';
import MapIdAutocomplete from '../../components/filters/Telemetry/MapIdAutocomplete.vue';
import SessionFilters from '../../components/filters/Telemetry/SessionFilters.vue'
export default {
  components: {
    PresetsAutocomplete,
    MapIdAutocomplete,
    SessionFilters
  },
  data () {
    return {
      panel: 0,
      tab: 'General',
      tabItems: [
        {
          name: 'General',
          path: ''
        },
        {
          name: 'Items',
          path: 'items'
        },
        {
          name: 'Combat',
          path: 'combat'
        },
        {
          name: 'Tension Beats',
          path: 'tension-beats'
        },
        {
          name: 'Main Character',
          path: 'main-character'
        },
        {
          name: 'UI',
          path: 'ui'
        }
      ]
    }
  },
  mounted () {
    if (this.$route.query.map_id) {
      this.map_id = this.$route.query.map_id
    }

    if (this.$route.query.build_id) {
      this.build_id = this.$route.query.build_id
    }

    if (this.$route.query.user_id) {
      this.user_id = this.$route.query.user_id
    }

    if (this.$route.query.session_id) {
      this.session_id = this.$route.query.session_id
    }

    if (this.$route.query.start_narration_node) {
      this.start_narration_node = this.$route.query.start_narration_node
    }

    if (this.$route.query.finish_narration_node) {
      this.finish_narration_node = this.$route.query.finish_narration_node
    }

    if (this.$route.query.finish && this.$route.query.finish[1]) {
      this.finish_event_id = this.$route.query.finish[1]
    }

    if (this.$route.query.session_min_time) {
      this.session_min_time = this.$route.query.session_min_time
    }

    if (this.$route.query.encounter_name) {
      this.encounter_name = this.$route.query.encounter_name
    }

    this.updateRouterQuery()
  },
  watch: {
    async map_id (val) {
      if (val) {
        this.build_id = null
        this.user_id = null
        this.session_id = null
        this.start_narration_node = null
        this.finish_narration_node = null
        this.updateRouterQuery()
      }
    },
    build_id () {
      this.updateRouterQuery()
    },
    user_id () {
      this.updateRouterQuery()
    },
    session_id () {
      this.updateRouterQuery()
    },
    start_narration_node () {
      this.updateRouterQuery()
    },
    finish_narration_node () {
      this.updateRouterQuery()
    },
    finish_event_id () {
      this.updateRouterQuery()
    },
    session_min_time () {
      this.updateRouterQuery()
    },
    encounter_name () {
      this.updateRouterQuery()
    }
  },
  computed: {
    map_id: {
      get () {
        return this.$store.state.telemetry.map_id
      },
      set (val) {
        this.$store.commit('telemetry/SET_MAP_ID', val)
      }
    },
    build_id: {
      get () {
        return this.$store.state.telemetry.build_id
      },
      set (val) {
        this.$store.commit('telemetry/SET_BUILD_ID', val)
      }
    },
    user_id: {
      get () {
        return this.$store.state.telemetry.user_id
      },
      set (val) {
        this.$store.commit('telemetry/SET_USER_ID', val)
      }
    },
    session_id: {
      get () {
        return this.$store.state.telemetry.session_id
      },
      set (val) {
        this.$store.commit('telemetry/SET_SESSION_ID', val)
      }
    },
    start_narration_node: {
      get () {
        return this.$store.state.telemetry.start_narration_node
      },
      set (val) {
        this.$store.commit('telemetry/SET_START_NARRATION_NODE', val)
      }
    },
    finish_narration_node: {
      get () {
        return this.$store.state.telemetry.finish_narration_node
      },
      set (val) {
        this.$store.commit('telemetry/SET_FINISH_NARATION_NODE', val)
      }
    },
    finish_event_id: {
      get () {
        return this.$store.state.telemetry.finish_event_id
      },
      set (val) {
        this.$store.commit('telemetry/SET_FINISH_EVENT_ID', val)
      }
    },
    session_min_time: {
      get () {
        return this.$store.state.telemetry.session_min_time
      },
      set (val) {
        this.$store.commit('telemetry/SET_SESSION_MIN_TIME', val)
      }
    },
    encounter_name: {
      get () {
        return this.$store.state.telemetry.encounter_name
      },
      set (val) {
        this.$store.commit('telemetry/SET_ENCOUNTER_NAME', val)
      }
    }
  },
  methods: {
    updateFilters (data) {
      Object.keys(data).forEach(key => {
        this[key] = data[key]
      })
    },
    updateRouterQuery () {
      const flag = !(
        this.$route.query.map_id === this.map_id &&
        this.$route.query.build_id === this.build_id &&
        this.$route.query.user_id === this.user_id &&
        this.$route.query.session_id === this.session_id &&
        this.$route.query.start_narration_node === this.start_narration_node &&
        this.$route.query.finish_narration_node === this.finish_narration_node &&
        ((this.$route.query.finish && this.$route.query.finish[1] || null) === this.finish_event_id) &&
        this.$route.query.session_min_time === this.session_min_time &&
        this.$route.query.encounter_name === this.encounter_name
      )

      if (flag) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            map_id: this.map_id,
            build_id: this.build_id,
            user_id: this.user_id,
            session_id: this.session_id,
            start_narration_node: this.start_narration_node,
            finish_narration_node: this.finish_narration_node,
            finish: this.$route.query.finish && this.$route.query.finish !== 'null' ? this.$route.query.finish : null,
            session_min_time: this.session_min_time,
            encounter_name: this.encounter_name
          }
        })
      }
    },
    removeFinish () {
      this.$router.replace({
        path: this.$route.path,
        query: {
          map_id: this.map_id,
          build_id: this.build_id,
          user_id: this.user_id,
          session_id: this.session_id,
          start_narration_node: this.start_narration_node,
          finish_narration_node: this.finish_narration_node,
          finish: null,
          session_min_time: this.session_min_time,
          encounter_name: this.encounter_name
        }
      })
    },
    presetSelected ({ build_id, map_id }) {
      this.map_id = map_id
      this.$nextTick(() => {
        this.build_id = build_id
      })
    }
  }
}
</script>
